import { ReactElement } from "react";

import "./Spinner_style.css";

type Props = {
    align?: "start" | "center" | "end";
    size?: number;
};

export default function Spinner({
    align = "center",
    size = 32,
}: Props): ReactElement {
    return (
        <span
            className="spinner-wrapper"
            style={{
                minWidth: `${size}px`,
                height: `${size}px`,
                alignContent: align,
                justifyContent: align,
            }}
        >
            <span
                className="spinner"
                style={{ width: `${size}px`, height: `${size}px` }}
            />
            <span
                className="spinner-2"
                style={{
                    width: `${size}px`,
                    height: `${size}px`,
                }}
            />
        </span>
    );
}
